// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "link-module--base-text-alt--global--efe59";
export var baseTextGlobal = "link-module--base-text--global--3935d";
export var blockSpacing100 = "link-module--block-spacing-100--1f821";
export var blockSpacing50 = "link-module--block-spacing-50--3eba2";
export var blockVPadding100 = "link-module--block-v-padding-100--0479b";
export var blockVPadding50 = "link-module--block-v-padding-50--2e5c1";
export var captionTextGlobal = "link-module--caption-text--global--558cf";
export var cmsRenderedContentGlobal = "link-module--cms-rendered-content--global--b2c98";
export var container = "link-module--container--6d7fe";
export var defaultHSpacingGlobal = "link-module--default-h-spacing--global--1ea5c";
export var fadeInAnimation = "link-module--fadeInAnimation--2bb10";
export var fadeInOnLoadGlobal = "link-module--fade-in-on-load--global--5efba";
export var fullHeightGlobal = "link-module--full-height--global--4b1ba";
export var fullHeightOmittingNavGlobal = "link-module--full-height-omitting-nav--global--c1afc";
export var headingTextGlobal = "link-module--heading-text--global--4ecde";
export var ingressTextGlobal = "link-module--ingress-text--global--11d47";
export var linkColorChangeTransitionGlobal = "link-module--link-color-change-transition--global--95d63";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "link-module--page-heading-text--global--57e6a";
export var paragraphTextGlobal = "link-module--paragraph-text--global--2e629";
export var subheadingTextGlobal = "link-module--subheading-text--global--c0005";